var HomeDataTestIdEnum = /* @__PURE__ */ ((HomeDataTestIdEnum2) => {
  HomeDataTestIdEnum2["HOME_ALERT_NO_LOCATION"] = "home--alert-no-location";
  HomeDataTestIdEnum2["HOME_BANNER_SECTION"] = "home--banner-section";
  HomeDataTestIdEnum2["HOME_BENEFITS_SECTION"] = "home--benefits-section";
  HomeDataTestIdEnum2["HOME_BRAND_SECTION"] = "home--brand-section";
  HomeDataTestIdEnum2["HOME_CAROUSEL"] = "home-carousel";
  HomeDataTestIdEnum2["HOME_FACE_TO_FACE_SECTION"] = "home--face-to-face-service-section";
  HomeDataTestIdEnum2["HOME_FAVORITES_SECTION"] = "favorites-title--card-home";
  HomeDataTestIdEnum2["HOME_FIND_PHYSICAL_UNIT_SECTION"] = "home--find-physical-unit-section";
  HomeDataTestIdEnum2["HOME_LOCATION_CONTAINER"] = "location-container";
  HomeDataTestIdEnum2["HOME_LOCATION_SEARCH_INPUT"] = "search-input--location-modal";
  HomeDataTestIdEnum2["HOME_MOST_SEARCHED_ALERT_BANNER"] = "most-searched-alert-banner";
  HomeDataTestIdEnum2["HOME_MOST_SEARCHED_ITEM"] = "most-searched-item";
  HomeDataTestIdEnum2["HOME_MOST_SEARCHED_ITEM_PRICE"] = "home-most-searched-item-price";
  HomeDataTestIdEnum2["HOME_MOST_SEARCHED_SECTION"] = "home--most-searched-section";
  HomeDataTestIdEnum2["HOME_PHYSICAL_UNITS_SECTION"] = "home--physical-units-section";
  HomeDataTestIdEnum2["HOME_SEARCH_INPUT_SECTION"] = "home--search-input-section";
  HomeDataTestIdEnum2["HOME_SEARCH_TITLE"] = "home--search-title";
  HomeDataTestIdEnum2["HOME_TESTIMONIAL_SECTION"] = "home--testimonial-section";
  HomeDataTestIdEnum2["PHYSICAL_UNITS_BUTTON_WHATS_APPOINTMENT"] = "physical-units--button-whats-appointment";
  HomeDataTestIdEnum2["PHYSICAL_UNITS_CARD"] = "physical-units--card";
  HomeDataTestIdEnum2["PHYSICAL_UNITS_CAROUSEL"] = "physical-units--carousel";
  HomeDataTestIdEnum2["SEARCH_MODAL"] = "generic-modal--search-modal";
  HomeDataTestIdEnum2["SIGN_IN_MODAL"] = "generic-modal--sign-in-modal";
  HomeDataTestIdEnum2["TESTIMONIAL_CARROUSEL"] = "tes-carousel-about-us";
  HomeDataTestIdEnum2["TESTIMONIAL_SECTION_ABOUT_US"] = "testimonial-section-about-us";
  return HomeDataTestIdEnum2;
})(HomeDataTestIdEnum || {});
export {
  HomeDataTestIdEnum
};
